import React, { useEffect, useState } from "react";
import { Collapse } from "react-collapse";
import { Col, Row } from "react-grid-system";
import { useTranslation } from "react-multi-lang";
import { useDispatch, useSelector } from "react-redux";

import {
  InputField,
  NumberField,
  SelectField,
} from "../../components/FormElements/FormElements";

import { EllipsisLoader } from "../../components/Loader/Loader";

import {
  CategoriesMenu,
  ClassesMenu,
  FinancialStatusMenu,
} from "../../components/PredefinedMenus/PredefinedMenus";

import "./Stage.css";

import { answer, StageSlice, StageState, question } from "./StageSlice";

import select_vector from "../../assets/images/vectors/select.svg";

import { toast } from "react-toastify";
import { Prompt } from "react-router-dom";

import StageApi from "../../services/api/stage";
import { Confirm } from "../../components/Alerts/Alerts";

export default () => {

  const [isLoaded, setIsLoaded] = useState(false);
  const [classType, setClassType] = useState<any>(null);
  const [isSaving, setIsSaving] = useState(0);
  const [shouldSave, setShouldSave] = useState(false);

  const dispatch = useDispatch();
  const state = useSelector((state: { stage: StageState }) => state.stage);

  const ENDPOINTS = new StageApi();
  const t = useTranslation();

  /* ========================
     Helpers
  ======================== */

 const isSaved = () => {
  if (!classType) return false;

  const questions = state?.questions || [];

  if (questions.length === 0) return false;

  return questions.every(q => q.status === "saved") && !shouldSave;
};

  /* ========================
     Delete handlers
  ======================== */

  const deleteAnswerHandler = async (q_index: number, a_index: number) => {
    const answerItem = state.questions?.[q_index]?.answers?.[a_index];
    if (!answerItem) return;

    if (answerItem.id) {
      try {
        await ENDPOINTS.stage().deleteOption(answerItem.id);
        dispatch(StageSlice.actions.removeAnswer({ q_index, a_index }));
        toast("Answer deleted");
      } catch {
        toast.error("Failed to delete answer");
      }
    } else {
      dispatch(StageSlice.actions.removeAnswer({ q_index, a_index }));
    }
  };

  const deleteQuestionHandler = async (q_index: number) => {
    const questionItem = state.questions?.[q_index];
    if (!questionItem) return;

    if (questionItem.id) {
      try {
        await ENDPOINTS.stage().deleteQuestion(questionItem.id);
        dispatch(StageSlice.actions.deleteQuestion(questionItem.id));
        toast("Question deleted");
      } catch {
        toast.error("Failed to delete question");
      }
    } else {
      dispatch(StageSlice.actions.deleteQuestionByIndex(q_index));
    }
  };

  /* ========================
     Fetch questions
  ======================== */

useEffect(() => {
  if (!classType) return;

  setIsLoaded(false);

  ENDPOINTS.stage()
    .stage({ class_type_id: classType.value })
    .then((response: any) => {
      const questions = response?.data?.data;
console.log(questions);
      if (!questions || !Array.isArray(questions)) {
        // API فاضي أو خطأ
        dispatch(StageSlice.actions.setQuestions([]));
        setIsLoaded(true);
        return;
      }

 dispatch(
  StageSlice.actions.setQuestions(
    questions.map((q: any) => ({
      id: q.id,
      question: q.text,
      status: "saved",
      answers:
        q.options?.map((o: any) => {
          const result = o.results?.[1];

          return {
            id: o.id,
            answer: o.text,
            type: o.type,
            with_value: o.with_value,
            start_range: result?.range_start ?? null,
            end_range: result?.range_end ?? null,
          };
        }) || [],
    }))
  )
);

      setIsLoaded(true);
    })
    .catch((err:any) => {
     console.log(err);
      dispatch(StageSlice.actions.setQuestions([]));
      setIsLoaded(true);
    });
}, [classType]);


  /* ========================
     Save
  ======================== */

  const save = async () => {

    const questions = state.questions
      .filter(q => q.status !== "saved" && q.question)
      .map(q => ({
        id: q.id,
        question: q.question,
        options: q.answers
          ?.filter(a => a.answer)
  .map(a => {
        
        const hasRange =
          a.start_range !== undefined &&
          a.start_range !== "" &&
          a.end_range !== undefined &&
          a.end_range !== "";

        return {
          id: a.id,
          text: a.answer,
          value: a.answer,
          results: [{
            range_start: a.start_range,
            range_end: a.end_range,
            with_range: hasRange ? "Yes" : "No",   
            stage_id:a.stage_id
          },],
          _deleted: a._deleted ?? false,
          with_value: a.with_value,
        };
      }),
      }));

    if (questions.length === 0 && !shouldSave) {
      toast("Your data is already saved!");
      return;
    }

    setShouldSave(false);

    for (let i = 0; i < questions.length; i++) {

      const question = questions[i];

      const index = state.questions.findIndex(
        q => q.question === question.question
      );

      if (index === -1) continue;

      dispatch(
        StageSlice.actions.editQuestion({
          index,
          question: { isSaving: true },
        })
      );

      setIsSaving(prev => prev + 1);

      if (question.id) {

        const res = await ENDPOINTS.stage().update(question);
        const q = res.data.data;

        dispatch(
          StageSlice.actions.editQuestion({
            index,
            question: {
              id: q.id,
              status: "saved",
              isSaving: false,
              answers: q.options.map(
                (o: any): answer => ({
                  id: o.id,
                  answer: o.text,
                  type:o.type
                })
              ),
            },
          })
        );

      } else {

        const res = await ENDPOINTS.stage().store({
          ...question,
          class_type_id: classType.value,
        });

        const q = res.data.data;

        dispatch(
          StageSlice.actions.editQuestion({
            index,
            question: {
              id: q.id,
              status: "saved",
              isSaving: false,
              answers: q.options.map(
                (o: any): answer => ({
                  id: o.id,
                  answer: o.text,
                   type:o.type
                })
              ),
            },
          })
        );
      }

      setIsSaving(prev => prev - 1);
    }
  };

  /* ========================
     Render
  ======================== */

  return (
    <>
   
    <div className="irs">

      <form onSubmit={e => e.preventDefault()}>
        <Row>
          <Col md={4}>
            <label>{t("class_type")}</label>
            <ClassesMenu
              onChange={(selected: any) => setClassType(selected)}
              placeholder="Class type"
            />
          </Col>

          {classType && isLoaded && (
            <>
              <Col md={6}>
                <h3>
                  Questions related to {classType.label}
                </h3>
              </Col>

              <Col md={2} className="text-right">
                <button
                  className="button bg-gold color-white"
                  style={isSaving || isSaved() ? { opacity: 0.5 } : {}}
                  disabled={isSaving > 0 || isSaved()}
                  onClick={save}
                >
                  {isSaving ? "Saving..." : "Save"}
                </button>
              </Col>
            </>
          )}
        </Row>
      </form>

      {classType ? (

        isLoaded ? (
          <div className="questions">
         
            {state?.questions
.map((question, q_index) => (

              <div key={q_index} className="question margin-top-20">
                <header>
                  <input
                    placeholder="Type a question"
                    value={question.question}
                    onChange={e =>
                      dispatch(
                        StageSlice.actions.editQuestion({
                          index: q_index,
                          question: { question: e.target.value },
                        })
                      )
                    }
                  />

                  <i
                    className="icon-delete"
                    onClick={() => {
 Confirm({
      message: t("delete_confirmation"),
      onConfirm: async () => {
        try {
       deleteQuestionHandler(q_index)

    

        } catch (error: any) {
          console.error("Delete force grade error:", error);

          // 🔹 رسالة من الباك إند
          if (error.response) {
            toast.error(
              error.response.data?.message || t("server_error")
            );
          }
          // 🔹 مشكلة شبكة
          else if (error.request) {
            toast.error(t("network_error"));
          }
          // 🔹 أي خطأ آخر
          else {
            toast.error(t("unexpected_error"));
          }
        }
      },
    });


                    }}
                  />
                </header>

                <Collapse isOpened>
<ul>
  {question.answers
    ?.filter(a => !a._deleted)
    .map((answer, a_index) => (

      <li key={a_index}   style={{
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    alignItems: "center",
    marginBottom: "10px"
  }}>
<div style={{ minWidth: "220px", flex: 1 }}>
        {/* Select */}
        <SelectField
          placeholder="Answer"
          options={[
            { label: "نعم", value: "Yes" },
            { label: "لا", value: "No" },
            { label: "غير موجود", value: "Others" },
          ]}



          value={
            answer.type
              ? {
                  label:
                    answer.type === "Yes"
                      ? "نعم"
                      : answer.type === "No"
                      ? "لا"
                      : "غير موجود",
                  value: answer.type,
                }
              : null
          }
          onChange={(selected:any) => {

            let answerText =
              selected.value === "Yes"
                ? "نعم"
                : selected.value === "No"
                ? "لا"
                : "غير موجود";

            dispatch(
              StageSlice.actions.editAnswer({
                q_index,
                a_index,
                answer: {
                  answer: answerText,
                  type: selected.value,
                },
              })
            );
          }}
        />
</div>

 {answer.type === "Yes" && (
  <>
        {/* Checkbox */}
        <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <input
            type="checkbox"
            checked={answer.with_value === "Yes"}
            onChange={(e) => {
              dispatch(
                StageSlice.actions.editAnswer({
                  q_index,
                  a_index,
                  answer: {
                    with_value: e.target.checked ? "Yes" : "No",
                  },
                })
              );
            }}
          />
          With value
        </label>

     
        {answer.with_value === "Yes" && (
          <>
            <input
              type="number"
              placeholder="Start range"
              value={answer.start_range || ""}
              onChange={(e) =>
                dispatch(
                  StageSlice.actions.editAnswer({
                    q_index,
                    a_index,
                    answer: { start_range: e.target.value },
                  })
                )
              }
              style={{ width: "90px" }}
            />

            <input
              type="number"
              placeholder="End range"
              value={answer.end_range || ""}
              onChange={(e) =>
                dispatch(
                  StageSlice.actions.editAnswer({
                    q_index,
                    a_index,
                    answer: { end_range: e.target.value },
                  })
                )
              }
              style={{ width: "90px" }}
            />


          </>
        )}
            {/* Stage dropdown */}
<select
  value={answer.stage_id || ""}
  onChange={(e) =>
    dispatch(
      StageSlice.actions.editAnswer({
        q_index,
        a_index,
        answer: { stage_id: Number(e.target.value) },
      })
    )
  }
  style={{
    minWidth: "120px",
    padding: "6px",
    borderRadius: "6px",
    border: "1px solid #ccc",
  }}
>
  <option value="">Stage</option>
  <option value={1}>Stage 1</option>
  <option value={2}>Stage 2</option>
  <option value={3}>Stage 3</option>
</select>
</>
 )}

        {/* Delete */}
        <i
          className="icon-delete"
          onClick={() => {

 Confirm({
      message: t("delete_confirmation"),
      onConfirm: async () => {
        try {
      deleteAnswerHandler(q_index, a_index)

    

        } catch (error: any) {
          console.error("Delete force grade error:", error);

      
          if (error.response) {
            toast.error(
              error.response.data?.message || t("server_error")
            );
          }
       
          else if (error.request) {
            toast.error(t("network_error"));
          }
       
          else {
            toast.error(t("unexpected_error"));
          }
        }
      },
    });



          }}
        />

      </li>
    ))}

  <button
    className="button color-gold margin-top-30"
    onClick={() =>
      dispatch(
        StageSlice.actions.addAnswer({
          q_index,
          answer: {
            with_value: "No",
          },
        })
      )
    }
  >
    Add answer
  </button>
</ul>


                </Collapse>
              </div>
            ))}

            <button
              className="button bg-gold color-white margin-top-30"
              onClick={() =>
                dispatch(StageSlice.actions.addQuestion({ answers: [] }))
              }
            >
              Add question
            </button>

          </div>

        ) : (
          <div className="text-center margin-top-50">
            <EllipsisLoader />
          </div>
        )

      ) : (
        <div className="text-center margin-top-30">
          <img src={select_vector} style={{ maxWidth: 300 }} />
          <p>Please select a class type</p>
        </div>
      )}

      {!isSaved() && (
        <Prompt message="You have unsaved changes, are you sure you want to leave?" />
      )}

    </div></>
  );
};
